/* ============
 * Mutations for the user module
 * ============
 *
 * The mutations that are available on the
 * user module.
 */

export default {
  setUser (state, payload) {
    state.user = payload.data
  },
  setNames (state, payload) {
    state.names = payload.split(' ')[0]
  },
  setInitialData (state, payload) {
    state.initialValues = payload
  },
  setCodeUser (state, payload) {
    state.coUs = payload
  },
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  },
  /**
   * Guarda la sesión de CR Auth y sincroniza el token y el vencimiento que lee el resto del front.
   * `exp` es el vencimiento del refresh token: Protected.vue cierra la sesión cuando pasa.
   */
  setSession (state, session) {
    state.session = session
    state.jwt = session.accessToken
    state.exp = session.refreshExpiresAt
    if (state.user) {
      state.user = Object.assign({}, state.user, { jwtToken: session.accessToken, exp: session.refreshExpiresAt })
    }
  },
  /**
   * La sesión venció o CR Auth la rechazó. main.js escucha esta mutación para avisar al usuario.
   */
  expireSession (state) {
    state.session = null
    state.jwt = null
    state.coUs = null
    state.info = null
    state.user = null
    state.polizas = null
    state.historyPayments = null
    state.exp = null
    state.names = null
  },
  setIP (state, payload) {
    state.ip = payload
  },
  setPolizas (state, payload) {
    state.polizas = payload
  },
  setPolizasVidaVehicular (state, payload) {
    state.polizasVidaVehicular = payload
  },
  setBasicInfo (state, payload) {
    state.info = payload.data
  },
  setHistoryPayments (state, payload) {
    state.historyPayments = payload
  },
  setElectronicDocs (state, payload) {
    state.electronicDocs = payload
  },
  setHaveLoanRequested (state, payload) {
    state.haveLoanRequested = payload
  },
  setNiubizSessionKey (state, payload) {
    state.niubizSessionKey = payload
  },
  setSearch (state, payload) {
    state.search = payload
  },
  setFunctions (state, payload) {
    state.functions = payload
  },
  clear (state) {
    state.user = null
    state.initialValues = null
    state.prestamosVidaDisponibilidad = null
  },
  setExtra (state, payload) {
    state.extra = payload
  },
  setPrestamosVidaDisponibilidad (state, payload) {
    state.prestamosVidaDisponibilidad = payload
  },
  marcarSolicitudPrestamoVidaEnEvaluacion (state) {
    const base = state.prestamosVidaDisponibilidad || {
      codigoRespuesta: '01',
      prestamoVidaHabilitado: true,
      polizas: []
    }
    state.prestamosVidaDisponibilidad = Object.assign({}, base, { tieneSolicitudEnEvaluacion: true })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js